var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login",staticStyle:{"direction":"rtl"}},[_c('div',{staticClass:"p-grid p-jc-center"},[_c('system-messages-display',{staticClass:"p-pt-3 system-messages-display"})],1),_c('div',{staticClass:"p-grid p-jc-center p-pt-3"},[_c('PresenceShow',{staticClass:"presence-show"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }